export default __webpack_public_path__ + "b0f35958aca7dde96ebd213276df6c95.ttf";